import BaseValidator from 'services/validations/base-validator';

class CompetitionsNotBlankValidator extends BaseValidator {
    private errorMessage = 'Competitions cannot be blank.';

    public setErrorMessage(errorMessage: string): void {
        this.errorMessage = errorMessage;
    }

    protected runValidation(): void {
        // @ts-ignore
        const {stacking} = this.dependencies;
        const items = stacking.getItems();

        for (let item of Object.values(items)) {
            // @ts-ignore
            if (!item.getCompetitionId()) {
                this.addCompetitionBlankError();
                break;
            }
        }
    }

    private addCompetitionBlankError(): void {
        const {errorMessage} = this;

        this.addError(errorMessage);
    }
}

export default CompetitionsNotBlankValidator;
